import { UserNewsletterSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const UserNewsletterModel: SelectorModel = {
  name: 'userNewsletters',
  getSelector: UserNewsletterSelectors.selectAllUserNewslettersDictionary,
  isReady: UserNewsletterSelectors.selectIsReadyUserNewsletter
};
